import { FunctionComponent } from "react";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import { Button, Jumbotron } from "react-bootstrap";
import * as React from "react";

export interface SuccessAlertProps {
  title: string;
  description: string;
  buttonText: string;
  showLink: boolean;
  onClick: () => void;
}

const splitLink = (str: string): string[] => {
  return str.split("edalnice.cz");
};

const description1 = (str: string, showLink: boolean): string => {
  if (!showLink) {
    return str;
  }

  return splitLink(str)[0];
};

const description2 = (str: string, showLink: boolean): string => {
  if (!showLink) {
    return " ";
  }

  return splitLink(str)[1] ?? "";
};

export const SuccessAlert: FunctionComponent<SuccessAlertProps> = (props: SuccessAlertProps) => {
  return (
    <Jumbotron className="p-3 p-lg-2 p-xl-3 text-center">
      <div style={{ padding: "2.4rem" }}>
        <Icon icon={IconType.CircleCheck} width={84} height={84} className="mb-3 text-success" />
        <h5 style={{ paddingTop: "10px" }}>{props.title}</h5>
        <div className="mb-4 px-3" style={{ paddingBottom: "20px" }}>
          {description1(props.description, props.showLink)}
          {props.showLink && (
            <>
              <a href="https://edalnice.cz">edalnice.cz</a>
            </>
          )}
          {description2(props.description, props.showLink)}
        </div>
        <Button
          type="submit"
          variant="primary"
          className="d-block mx-auto mt-2 mb-2 mw-100 text-wrap"
          style={{ paddingLeft: "50px", paddingRight: "50px" }}
          onClick={props.onClick}>
          {props.buttonText.toUpperCase()}
        </Button>
      </div>
    </Jumbotron>
  );
};
